<template>
	<v-card :elevation="1" :class="cardClasses" width="100%">
	<div class="d-flex" style="width: 100%">
		<views-panel
			v-if="infoData && infoData.hasViews && $store.getters.isOnline && !subFilters"
			:modelDef="infoData.modelDef"
			:advancedFilters="advancedFilters"
			:subFilters="subFilters"
		/>
		<div :class="{ 'flex-grow-1': true }" style="min-width: 0; width: 100%">
        <v-card-title class="px-3 py-2">
			<v-badge v-if="$store.getters.isOnline" v-model="filtered" color="primary" class="d-flex">
				<v-icon slot="badge" dark>filter_list</v-icon>
				<div>
					<p class="pl-2 pl-xl-3">{{ $trans(title) }}</p>
				</div>
				<div>
					<p v-if="entityTitle" class="entity-title">&nbsp;&nbsp;{{ entityTitle }}</p>
				</div>
				<div>
					<span class="fs12 grey--text">&nbsp;{{ filterSelectedName }}</span><span class="fs12 grey--text">{{ getUsersLimit }}</span>				
				</div>
			</v-badge>
			<template v-else>
				<div>
					<p class="pl-2 pl-xl-3">{{ title }}</p>
				</div>
				<div>
					<p v-if="entityTitle" class="entity-title">{{ entityTitle }}</p>
				</div>
			</template>
			<v-spacer></v-spacer>
			<v-spacer></v-spacer>

			<template v-if="mapPermission && $store.getters.isOnline">
				<v-btn icon class="mr-4" @click="toggleMaps()">
					<v-tooltip top>
						<template v-slot:activator="{ on }">
							<v-icon v-on="on">{{ showMaps ? 'toc' : 'pin_drop' }}</v-icon>
						</template>
						<span>{{ showMaps ? 'Tabella' : 'Mappa' }}</span>
					</v-tooltip>
				</v-btn>
			</template>

			<v-text-field class="hidden-xs-only font-weight-regular"
				append-icon="search"
				label="Cerca"
				v-model="search"
				clearable
				hide-details
				outlined
				dense
			></v-text-field>
			<v-btn
				v-if="$store.getters.isOnline && $store.getters.checkSettings('global_search') && infoData.meilisearch"
				icon
				@click="toggleMeiliSearch"
				class="ml-1">
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-icon v-on="on" :color="useMeiliSearch ? 'primary' : ''">mdi-search-web</v-icon>
					</template>
					<span>{{ useMeiliSearch ? 'Ricerca Smart (ON)' : 'Ricerca Standard' }}</span>
				</v-tooltip>
			</v-btn>
			<div v-if="$store.getters.isOnline" class="d-inline-flex align-center ml-1">
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-btn icon v-on="on" @click="manualRefresh">
							<v-icon :class="{ 'spin-animation': refreshing }">mdi-refresh</v-icon>
						</v-btn>
					</template>
					<span>Aggiorna</span>
				</v-tooltip>
				<v-menu offset-y left content-class="round-card" :close-on-content-click="false" :min-width="200">
					<template v-slot:activator="{ on: menuOn }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltipOn }">
								<v-btn x-small icon v-on="{ ...menuOn, ...tooltipOn }" class="auto-refresh-toggle">
									<v-badge :value="!!autoRefreshInterval" color="primary" dot overlap>
										<v-icon small>mdi-timer-outline</v-icon>
									</v-badge>
								</v-btn>
							</template>
							<span>{{ autoRefreshInterval ? `Auto-refresh: ${autoRefreshLabel}` : 'Auto-refresh' }}</span>
						</v-tooltip>
					</template>
					<v-list dense>
						<v-subheader class="pt-2 fs12i" style="height: 24px">Auto-refresh</v-subheader>
						<v-list-item
							v-for="option in autoRefreshOptions"
							:key="option.value"
							@click="setAutoRefresh(option.value)"
							:class="{ 'primary--text': autoRefreshInterval === option.value }">
							<v-list-item-icon>
								<v-icon v-if="autoRefreshInterval === option.value" small color="primary">mdi-check</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>{{ option.text }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-menu>
			</div>
			<v-btn v-if="infoData.availableFilters && $store.getters.isOnline" icon @click.native="showFiltersDrawer = true" class="ml-1">
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-badge v-on="on" :value="filtered" color="primary" dot overlap>
							<v-icon :color="filtered ? 'primary' : ''">filter_list</v-icon>
						</v-badge>
					</template>
					<span>Filtri avanzati</span>
				</v-tooltip>
			</v-btn>

			<columns-selector v-if="infoData.fieldDefs"
				:columns.sync="infoData.fieldDefs"
				:model-def="modelDef"
			></columns-selector>

			<v-menu v-if="infoData.menus" 
				content-class="round-card"
				:min-width="200"
				left
				offset-y>
				<template v-slot:activator="{ on }">
					<v-btn v-on="on" icon>
						<v-icon>mdi-dots-vertical</v-icon>
					</v-btn>
				</template>
				<v-list dense>
	                <v-subheader class="pt-2 fs12i" style="height: 24px">Vai</v-subheader>
					<template v-for="(menu, index) in infoData.menus">
						<v-list-item
							:key="index"
							ripple
							:to="menu.route">
							<v-list-item-icon>
								<v-icon style="font-size: 18px">{{ menu.icon }}</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>{{ menu.tooltip }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</template>
				</v-list>
			</v-menu>

			<v-toolbar-items v-if="actionsExpand">
				<v-btn icon text @click.stop="toggleActionsExpand()">
					<v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
				</v-btn>
			</v-toolbar-items>			

        </v-card-title>
		<v-divider></v-divider>

        <slot name="actions-expand"></slot>

		<!-- Numbering Gaps Alert - Global check for all sectionals -->
		<NumberingGapsContainer
			v-if="showNumberingAlert"
			:modelType="numberingModelType"
			:sectionalIds="numberingCheckSectionals"
		/>
		<v-divider v-if="showNumberingAlert"></v-divider>

		<v-container class="py-0" fluid>
			<v-row class="ma-0">
				<v-col cols="12" class="hidden-sm-and-up pa-3">
					<v-text-field 
						append-icon="search"
						label="Cerca"
						v-model="search"
						clearable
						hide-details
						outlined
						dense
					></v-text-field>
				</v-col>
			</v-row>
		</v-container>

		<advanced-filters-drawer
			v-if="infoData.availableFilters && $store.getters.isOnline"
			v-model="showFiltersDrawer"
			:infoAvailableFilters="infoData.availableFilters"
			:modelDef="infoData.modelDef"
			:filtered.sync="filtered"
			:get-cache="getCache"
			:filter-selected.sync="filterSelected"
			:crudSearch="search"
			:has-sort="pagination.sortBy && pagination.sortBy.length > 0"
			@clear-sort="clearSort"
		></advanced-filters-drawer>

		<div v-if="showSelectAllBanner && !showMaps" class="select-all-banner d-flex align-center justify-center py-1 body-2" data-test="select-all-banner">
			<template v-if="selectionProgress && selectionProgress.visible">
				<div class="d-flex align-center" data-test="selection-progress">
					<v-progress-circular indeterminate size="16" width="2" color="primary" class="mr-3"></v-progress-circular>
					Preparo i {{ selectionProgress.total.toLocaleString('it-IT') }} elementi selezionati…
					<span class="font-weight-medium ml-2">{{ selectionProgress.done.toLocaleString('it-IT') }} / {{ selectionProgress.total.toLocaleString('it-IT') }}</span>
					<v-btn text small color="info" class="ml-4" @click="cancelSelectionLoad">Annulla</v-btn>
				</div>
				<v-progress-linear absolute bottom height="2" color="primary"
					:value="selectionProgress.total ? 100 * selectionProgress.done / selectionProgress.total : 0"></v-progress-linear>
			</template>
			<template v-else>
				<span v-if="!allSelected" class="mr-4">Selezionati i {{ items.length }} elementi di questa pagina.</span>
				<v-checkbox :input-value="allSelected" @change="$event ? selectAll() : clearSelection()"
					:label="allSelected ? `Tutti i ${realTotalItems} elementi sono selezionati` : `Seleziona tutti i ${realTotalItems} elementi`"
					class="mt-0 pt-0" dense hide-details/>
			</template>
		</div>

		<v-data-table v-if="infoData.modelDef && !showMaps" class="background-2 enhanced-table"
			:options.sync="pagination"
			:headers="showHeaders"
			:items="items"
			:server-items-length="totalItems"
			:loading="loading"
			:search="realSearch"
			v-model="selected"
			fixed-header
			show-select
			multi-sort
			:dense="tableDense"
			:mobile-breakpoint="0"
			ref="vDataTable"
			:footer-props="{
				'items-per-page-options': [10, 25, 50, 100, 200, 500, { text: 'Tutti', value: -1 }],
				showFirstLastPage: true
			}">

			<!-- Empty state - no data at all -->
			<template v-slot:no-data>
				<!-- Show empty state when no data and no search/filters -->
				<v-container v-if="!loading && !search && !filtered" class="text-center py-8">
					<v-icon size="64" color="grey lighten-2">{{ getEmptyStateIcon }}</v-icon>
					<h3 class="mt-4 grey--text">{{ getEmptyStateTitle }}</h3>
					<p class="grey--text text--lighten-1">{{ getEmptyStateSubtitle }}</p>
					<v-btn
						v-if="canCreate"
						color="primary"
						@click="openCreate()"
						class="mt-4">
						<v-icon left>add</v-icon>
						{{ getEmptyStateAction }}
					</v-btn>
				</v-container>
				<!-- Show no results message when search/filters are active -->
				<v-container v-else-if="!loading" class="text-center py-8">
					<v-icon size="64" color="grey lighten-2">search_off</v-icon>
					<h3 class="mt-4 grey--text">Nessun risultato trovato</h3>
					<p class="grey--text text--lighten-1">
						Prova a modificare i criteri di ricerca o i filtri applicati
					</p>
					<v-btn text color="primary" @click="clearFilters()" class="mt-2">
						Rimuovi filtri
					</v-btn>
				</v-container>
			</template>

			<!-- Empty state - no search results (for compatibility) -->
			<template v-slot:no-results>
				<v-container v-if="!loading" class="text-center py-8">
					<v-icon size="64" color="grey lighten-2">search_off</v-icon>
					<h3 class="mt-4 grey--text">Nessun risultato trovato</h3>
					<p class="grey--text text--lighten-1">
						Prova a modificare i criteri di ricerca o i filtri applicati
					</p>
					<v-btn text color="primary" @click="clearFilters()" class="mt-2">
						Rimuovi filtri
					</v-btn>
				</v-container>
			</template>
			<template v-slot:header.data-table-select="{ on, props }">
				<v-simple-checkbox color="primary" v-bind="props" v-on="on"></v-simple-checkbox>
			</template>

			<template v-slot:item="{item, select, isSelected, expand, isExpanded, headers}">

				<tr class="cursor-pointer" :class="{'barred-row': isBarred(item)}" @contextmenu.prevent="openContextMenu($event, item)" :key="item.id">
					<template v-for="(header, h) in headers">
						<td :key="h" v-if="header.value == 'data-table-select'" :class="$vuetify.breakpoint.smAndDown ? 'pr-0' : ''">
							<v-simple-checkbox 
								color="primary"
								:value="isSelected"
								@input="select($event)" 
								>
							></v-simple-checkbox>
						</td>
						
						<td @click="openShow(item)" @click.middle="openShow(item, true)" v-else-if="header.type === 'advanced'" :key="h" :class="'text-'+(header.align?header.align:'left')">
							
							<v-tooltip v-if="header.value === 'condition'" bottom>
								<template v-slot:activator="{ on }">
									<v-icon v-on="on" :color="$eventBusUtility.conditionColor(item.condition)">warning</v-icon>
								</template>
								<span v-ripple>
									{{ item.trouble_condition_text }}
								</span>
							</v-tooltip>
							<v-tooltip v-else-if="header.value === 'deadline_type'" bottom>
								<template v-slot:activator="{ on }">
									<v-icon v-on="on" :color="$eventBusUtility.deadlineTypeColor(item.deadline_type)">mdi-cash-multiple</v-icon>
								</template>
								<span v-ripple>
									{{ item.deadline_type_text }}
								</span>
							</v-tooltip>
							<div v-else-if="header.subtype === 'sync_boolean'">
								<v-chip text-color="white" small :color="item[header.value] ? 'light-green accent-4' : 'light-blue accent-3'">{{ item[header.value] ? 'Si' : 'No' }}</v-chip>
							</div>
						</td>

						<td v-else-if="header.type === 'custom'" :key="h" @click="openShow(item)">
							<template v-if="header.subtype === 'sla_timer'">
								<div v-if="item.sla_time_remaining !== null && item.sla_time_remaining !== undefined" class="d-flex align-center" style="white-space: nowrap;">
									<v-icon x-small :color="item.sla_paused ? 'grey' : (item.sla_time_remaining > 0 ? (item.sla_time_remaining <= 60 ? 'warning' : 'success') : 'error')" class="mr-1">{{ item.sla_paused ? 'mdi-pause-circle' : 'mdi-circle' }}</v-icon>
									<span class="caption" :class="item.sla_time_remaining <= 0 ? 'error--text font-weight-bold' : (item.sla_paused ? 'grey--text' : '')">{{ formatSlaMinutes(item.sla_time_remaining) }}</span>
									<span class="caption grey--text ml-1">{{ item.sla_responded ? 'risoluzione' : 'risposta' }}</span>
									<span v-if="item.sla_paused" class="caption grey--text ml-1">(in pausa)</span>
								</div>
								<span v-else class="caption grey--text">—</span>
							</template>
							<div v-else :class="formatCustomClass(item[header.value])">{{ item[header.value] }}</div>
						</td>

						<td v-else-if="header.type === 'general_type'" :key="h" @click="openShow(item)">
							<template v-if="typeof infoData['general_types'][header.value][item[header.value]] !== 'undefined'">
								<template v-if="header.subtype == 'chip'">

									<v-chip v-if="item[header.value] && infoDataGeneralType(header.value, item) && infoDataGeneralType(header.value, item).color" :class="header.subtype" :text-color="$eventBusUtility.lightOrDark(infoDataGeneralType(header.value, item).color) == 'dark' ? 'white' : 'black'" small :color="infoDataGeneralType(header.value, item).color">{{ infoData['general_types'][header.value][item[header.value]].text }}</v-chip>
									
									<v-chip v-else-if="item[header.value]" :class="header.subtype" text-color="white" small>{{ infoData['general_types'][header.value][item[header.value]].text }}</v-chip>
								</template>
								<template v-else-if="header.subtype == 'squared-chip'">
									<template v-if="infoDataGeneralType(header.value, item) && infoDataGeneralType(header.value, item).color">
										<div class="squared-chip" :style="{'color': infoDataGeneralType(header.value, item).color}">
											{{ infoData['general_types'][header.value][item[header.value]].text }}
										</div>
									</template>
									<template v-else>
										<div class="squared-chip">
											{{ infoData['general_types'][header.value][item[header.value]].text }}
										</div>
									</template>
								</template>
								<template v-else-if="header.subtype == 'squared-chip-filled'">
									<template v-if="infoDataGeneralType(header.value, item) && infoDataGeneralType(header.value, item).color">
										<div class="squared-chip-filled" :style="{'background-color': infoDataGeneralType(header.value, item).color}">
											<span :style="{'color': $eventBusUtility.lightOrDark(infoDataGeneralType(header.value, item).color) == 'dark' ? 'white' : 'black'}">
												{{ infoData['general_types'][header.value][item[header.value]].text }}
											</span>
										</div>
									</template>
									<template v-else>
										<div class="squared-chip-filled">
											{{ infoData['general_types'][header.value][item[header.value]].text }}
										</div>
									</template>
								</template>
							</template>
						</td>

						<td v-else-if="header.type === 'currency'" :key="h" :class="header.class"
							@click="openShow(item)" @click.middle="openShow(item, true)"
							>
							{{ item[header.value] | currency(undefined, item.currency_text) }}
						</td>
						<td v-else-if="header.value === 'actions'" class="pl-0 background-2" :class="'text-'+(header.align?header.align:'left')" style="white-space: nowrap; width: 1%;" :key="h">
							<template v-if="reloadOffline">
								<v-tooltip v-for="(action, a) in visibleRowActions(header.actions)" bottom :key="a">
									<template v-slot:activator="{ on }">
										<!-- span come activator: le azioni di riga possono essere disabilitate per
										     singola riga (es. conversioni non ammesse dalla causale del documento)
										     e un pulsante disabilitato non riceve il mouse, quindi il tooltip con il
										     nome dell'azione non si aprirebbe -->
										<span v-if="action.url" v-on="on" class="d-inline-block">
											<v-btn
												icon
												small
												:class="$vuetify.breakpoint.smAndDown ? 'mx-1' : 'mx-0'"
												:disabled="checkDisabledAction(action, item)"
												@click.stop="$router.push({ name: action.url, params: {id:item.id, defaultInput: generateDefaultInput(item, action.defaultInput), ...action.params}})">
												<v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="action.color">{{ action.icon }}</v-icon>
											</v-btn>
										</span>
										<v-btn v-else-if="action.morph" v-on="on"
											icon
											small
											:class="$vuetify.breakpoint.smAndDown ? 'mx-1' : 'mx-0'"
											@click.stop="$router.push({ name: item[action.key]+action.morph, params: {id:item.id, defaultInput: generateDefaultInput(item, action.defaultInput)}})">
											<v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="action.color">{{ action.icon }}</v-icon>
										</v-btn>
										<v-btn v-else-if="action.download" v-on="on"
											icon
											small
											:class="$vuetify.breakpoint.smAndDown ? 'mx-1' : 'mx-0'"
											@click.stop="$eventBusUtility.openFile($store, '/download/'+item.id, item.name)">
											<v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="action.color">{{ action.icon }}</v-icon>
										</v-btn>
										<template v-else-if="action.dialog">
											<v-tooltip bottom v-if="action.action == 'edit'">
												<template v-slot:activator="{ on, attrs }">
													<v-btn v-bind="attrs" v-on="on"
														icon
														small
														:class="$vuetify.breakpoint.smAndDown ? 'mx-1' : 'mx-0'"
														:disabled="checkDisabledAction(action, item)"
														@click="openShow(item)" @click.middle="openShow(item, true)">
														<v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" color="teal">edit</v-icon>
													</v-btn>
												</template>
												<span>Modifica</span>
											</v-tooltip>
											<v-tooltip bottom v-else-if="action.action == 'clone'">
												<template v-slot:activator="{ on, attrs }">											
													<v-btn v-bind="attrs" v-on="on"
														icon
														small
														:class="$vuetify.breakpoint.smAndDown ? 'mx-1' : 'mx-0'"
														@click.native.stop="cloneItem(item)">
														<v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" color="blue">content_copy</v-icon>
													</v-btn>
												</template>
												<span>Duplica</span>
											</v-tooltip>
											<v-tooltip bottom v-else-if="action.action == 'delete'">
												<template v-slot:activator="{ on, attrs }">											
													<v-btn v-bind="attrs" v-on="on"
														icon
														small
														:class="$vuetify.breakpoint.smAndDown ? 'mx-1' : 'mx-0'"
														:disabled="checkDisabledAction(action, item)"
														@click.native.stop="crudDialogDelete(item)">
														<v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" color="pink">delete</v-icon>
													</v-btn>
												</template>
												<span>Elimina</span>
											</v-tooltip>
										</template>
										<v-tooltip bottom v-else-if="action.action == 'getcopy'">
											<template v-slot:activator="{ on, attrs }">											
												<v-btn v-bind="attrs" v-on="on"
													icon
													small
													:class="$vuetify.breakpoint.smAndDown ? 'mx-1' : 'mx-0'"
													:disabled="checkDisabledAction(action, item)"
													@click.native.stop="getCopy(item, action)">
													<v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="action.color">{{ action.icon }}</v-icon>
												</v-btn>
											</template>
											<span>{{ action.text }}</span>
										</v-tooltip>
										<v-tooltip bottom v-else-if="action.action == 'link'">
											<template v-slot:activator="{ on, attrs }">											
												<v-btn v-bind="attrs" v-on="on"
													icon
													small
													:class="$vuetify.breakpoint.smAndDown ? 'mx-1' : 'mx-0'"
													:disabled="checkDisabledAction(action, item)"
													@click.native.stop="goToLink(item, action)">
													<v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="action.color">{{ action.icon }}</v-icon>
												</v-btn>
											</template>
											<span>{{ action.text }}</span>
										</v-tooltip>
										<template v-else-if='action.component'>
											<component 
												:is="action.component"
												:model="item"
												:params="action"
												:button="action"
												:class="$vuetify.breakpoint.smAndDown ? 'mx-1' : 'mx-0'">
											</component>
										</template>
										<v-btn v-else-if="action.expand && item[action.field_key]"
											v-on="on"
											icon
											small
											:class="$vuetify.breakpoint.smAndDown ? 'mx-1' : 'mx-0'"
											@click="toggleExpand(item, isExpanded, expand)">
											<v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="action.color">{{ action.icon }}</v-icon>
										</v-btn>
									</template>
									<span>
										{{ action.text }}
									</span>
								</v-tooltip>
							</template>
						</td>

						<!-- <td v-else-if="header.link" @click.stop="openShow(item)" :key="h">
							<div style="font-weight: 500;" v-if="item[header.link.key]"   @click.stop="$eventBusUtility.goTo($router, header.link.modelDef, item[header.link.key])">
								{{ item[header.value] }}
							</div>
							<div v-else>
								{{ item[header.value] }}
							</div>
						</td> -->
						<td v-else-if="header.type === 'link'" :key="h" :class="header.class">
							<template v-if="item[header.link_key] && (!header.link_route_key || item[header.link_route_key])">
								<a @mousedown="goToLinkCell(header, item, $event)"
									class="text-decoration-underline"
									style="cursor: pointer">
									<v-icon v-if="header.link_icon_key || header.link_route_key" small class="mr-1" color="primary">{{ item[header.link_icon_key] || 'mdi-open-in-new' }}</v-icon>{{ item[header.value] }}
								</a>
								<!-- Relazioni morfiche: il sottotitolo dice di che entità si tratta -->
								<div v-if="header.subtitle_key && item[header.subtitle_key]" class="caption grey--text">
									{{ item[header.subtitle_key] }}
								</div>
							</template>
							<span v-else>-</span>
						</td>
						<td v-else-if="header.type === 'date'" @click="openShow(item)" @click.middle="openShow(item, true)" :key="h">
							<div>
								{{ item[header.value] | date }}
							</div>
						</td>

						<td v-else-if="header.type === 'datetime'" @click="openShow(item)" @click.middle="openShow(item, true)" :key="h">
							<div>
								{{ item[header.value] | datetime }}
							</div>
						</td>
						<td v-else-if="header.type === 'duration'" @click="openShow(item)" @click.middle="openShow(item, true)" :key="h">
							<div>
								{{ item[header.value] | duration }}
							</div>
						</td>
						<td v-else-if="header.type === 'byte'" @click="openShow(item)" @click.middle="openShow(item, true)" :key="h">
							<div>
								{{ item[header.value] | byte }}
							</div>
						</td>
						<td v-else-if="header.type == 'relation'" :class="'text-'+header.align" :key="h" @click="openShow(item)" @click.middle="openShow(item, true)">
							<v-chip v-for="(chip, c) in item[header.value]" x-small :key="c">
								<template v-if="header.customfield">{{ getChipText(header, chip) }}</template>
								<template v-else>{{ chip[header.subkey] }}</template>
							</v-chip>
						</td>
						<td v-else-if="header.type == 'chips'" :class="'text-'+header.align" :key="h" @click="openShow(item)" @click.middle="openShow(item, true)">
							<v-chip v-for="(chip, c) in JSON.parse(item[header.value])" small :key="c">
								<template v-if="header.customfield">{{ getChipText(header, chip) }}</template>
								<template v-else>{{ chip }}</template>
							</v-chip>
						</td>
						<td v-else-if="header.type == 'chip'" :class="'text-'+header.align" :key="h" @click="openShow(item)" @click.middle="openShow(item, true)">
							<v-chip small v-if="item[header.value]">
								<template v-if="header.customfield">{{ getChipText(header, item[header.value]) }}</template>
								<template v-else>{{ item[header.value] }}</template>
							</v-chip>
						</td>
						<td v-else-if="header.type == 'color'" :class="'text-'+header.align" :key="h" @click="openShow(item)" @click.middle="openShow(item, true)">
							<div :style="{'width': '48px', 'height': '18px', 'border-radius': '2px', 'background-color': item.color}"></div>
						</td>
						<td v-else-if="header.type == 'boolean'" :class="'text-'+header.align" :key="h" @click="openShow(item)" @click.middle="openShow(item, true)">
							<div>
								{{ item[header.value] == 1 ? 'Si' : 'No' }}
							</div>
						</td>
						<td v-else-if="header.value == 'business_callqueue_status'" :class="'text-'+(header.align?header.align:'left')" :key="h" @click="openShow(item)" @click.middle="openShow(item, true)">
							<div :class="$eventBusUtility.businessCallqueueStatus(item[header.value])">
								<v-icon size="10" style="color: inherit; margin-bottom: 2px;">fiber_manual_record</v-icon>
								<span class="font-weight-bold"> {{ $eventBusUtility.businessCallqueueText(item[header.value]) }}</span>
							</div>
						</td>
						<td v-else-if="header.type == 'outcome_chip'" :class="'text-'+(header.align?header.align:'left')" :key="h" @click="openShow(item)" @click.middle="openShow(item, true)">
							<v-chip v-if="item[header.value]" small :color="getOutcomeColor(item[header.value])" dark>
								{{ $eventBusUtility.callqueueOutcomeText(item[header.value]) }}
							</v-chip>
							<span v-else>-</span>
						</td>
						<td v-else-if="header.type === 'html'"
							class="text-"
							v-html="item[header.value]"
							@click="openShow(item)" @click.middle="openShow(item, true)"
							:key="h">
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-icon v-on="on" :color="$eventBusUtility.conditionColor(item.condition)">warning</v-icon>
								</template>
								<span>
									{{ header.text }}
								</span>
							</v-tooltip>
						</td>
						<td v-else-if="header.type === 'trans'" :key="h" @click="openShow(item)" @click.middle="openShow(item, true)"
							v-cell-expand>
							{{ $trans(item[header.value]) }}
						</td>
						<td v-else-if="header.text_value" :key="h" @click="openShow(item)" @click.middle="openShow(item, true)"
							v-cell-expand>
							{{ item[header.text_value] }}
						</td>
						<td v-else @click="openShow(item)" @click.middle="openShow(item, true)" :key="h" :class="header.class"
							v-cell-expand>
							{{ item[header.value] }}
						</td>
					</template>
				</tr>
				

			</template>
			<template v-slot:expanded-item="{ item, headers }">
				<td v-if="expandActionFieldKey" :colspan="headers.length" :class="{'ma-0 pa-0': true, 'expanded-closing': !transitioned[item.id]}" style="height: auto;">
					<v-expand-transition>
						<v-card class="elevation-0" v-show="transitioned[item.id]">
							<v-card-text pa-4 v-html="item[expandActionFieldKey]"></v-card-text>
						</v-card>
					</v-expand-transition>
				</td>
            </template>

			<!-- Riga dei totali di colonna configurabili: presente solo se almeno
			una colonna visibile ha il flag totale attivo e il backend ha
			restituito column_totals. Non tocca i footer esistenti
			(footerComponent, totals-footer, footer di paginazione) -->
			<template v-slot:body.append="{ headers }">
				<tr v-if="hasColumnTotalsRow" class="column-totals-row font-weight-bold">
					<template v-for="(header, h) in headers">
						<td v-if="header.value == 'data-table-select'" :key="'total-' + h" class="text-no-wrap">Totale</td>
						<td v-else :key="'total-' + h" :class="header.class" class="text-no-wrap">
							<template v-if="columnTotalValue(header) !== undefined">
								<template v-if="header.type === 'duration'">{{ columnTotalValue(header) | duration }}</template>
								<template v-else-if="header.type === 'currency'">{{ columnTotalValue(header) | currency(2) }}</template>
								<template v-else>{{ Number(columnTotalValue(header)).toLocaleString('it-IT') }}</template>
							</template>
						</td>
					</template>
				</tr>
			</template>

			<template v-slot:footer.page-text="{ pageStart, pageStop }">
				<div class="warning--text"><span class="warning--text">{{ countSelected }}</span> Selezionati</div>
				Da {{ pageStart }} a {{ pageStop }} di {{ realTotalItems }}
			</template>

		</v-data-table>

		<v-menu v-if="!crudDialog"
			v-model="contextMenu.show" :position-x="contextMenu.x"
			:position-y="contextMenu.y"
			content-class="round-card"
			eager>

			<v-list dense>
				<v-subheader class="pt-0 fs12i" style="height: 24px">Azioni</v-subheader>
				<v-list-item @click="openShow(contextMenu.item, true)" class="px-2">
					<v-list-item-icon>
						<v-icon style="font-size: 18px">mdi-open-in-new</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Apri in una nuova scheda</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-list-item 
				@click="editInNewTab(contextMenu.item.id)" class="px-2">
					<v-list-item-icon>
						<v-icon style="font-size: 18px">edit</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Modifica</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

			</v-list>
		</v-menu>

		<template v-if="infoData.modelDef && showMaps">
			<maps
				:modelDef="infoData.modelDef"
				:search="search"
				:advancedFilters="advancedFilters">
			</maps>
		</template>
		
        <component v-if="footerComponent"
            :is="footerComponent"
            :other-data="otherData"
        ></component>

		<totals-footer
			:totals="totals"
			:defs="infoData.totalsDefs">
		</totals-footer>

		<template v-if="!showMaps">
			<buttons-generator v-if="infoData.modelDef && $store.getters.isOnline"
				:info-data="infoData"
				:title="title"
				:default-input="defaultInput"
				:disabled.sync="disabled"
				:show-dial.sync="showDial"
				:speed-dial-options="speedDialOptions"
				:action-position="actionPosition"
				:action-icon="actionIcon"
				:selected="selected"
				:all-selected="allSelected"
				:count-selected="countSelected"
				:list-filters="listFilters"
				:resolve-all-selected="resolveAllSelected"
				:all-selected-rows="allSelectedRows"
				@export-csv="openExportDialog"
			></buttons-generator>
		</template>

		<crud-export-dialog
			v-model="exportDialog"
			:button="exportButton"
			:model-def="infoData.modelDef"
			:count="countSelected"
			:columns="showHeaders"
			:explicit-items="exportsWholeList ? null : selectedInTableOrder"
			:list-request="exportListRequest"
		></crud-export-dialog>

        <v-dialog v-model="showDialog" :key="model.id"
            max-width="870px"
            persistent
			scrollable
            :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-card v-draggable class="background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">{{ $trans(title) }}</p>
                    <v-spacer></v-spacer>
                </v-card-title>   
                <v-divider></v-divider>
                <v-card-text class="pa-0">
                    <v-container>
                        <div v-if="multipleEdit" class="subheading font-weight-light px-6 py-2">Elementi selezionati: <span class="font-weight-medium primary--text">{{ actionSelectedIds.length }}</span></div>
                        <fields-generator class="mt-4"
                            :fieldsset.sync="fieldsset"
                            :model="model"
                            ref="fieldsgenerator"
                        	:selectChange="onChange"
							:support="support"
							:multiple-edit="multipleEdit"
						></fields-generator>
						<div><small class="pl-4">* Indica i campi obbligatori</small></div>
						<div v-if="multipleEdit"><small class="pl-4">I campi non compilati non verranno modificati</small></div>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions class="px-2">
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click.native.stop="closeDialog()">Chiudi</v-btn>
                    <v-btn color="primary" text :loading="saved" @click.native="saveModel()">{{ type == 'clone' ? 'Duplica' : 'Salva' }}</v-btn>
                    <v-btn v-if="saveAndNew && type != 'clone'" color="success" text :loading="saved" @click.native="saveModel(true)">Salva e Nuovo</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <confirm-dialog
			:confirmModel="confirmDelete"
			mainTitle="Eliminare gli elementi selezionati?"
			secondTitle="Gli elementi selezionati verranno eliminati solamente se indipendenti e non collegati a nessun altra entità. Una volta eliminati non sarà possibile ripristinarli"
			@update:confirmModel="cancelCrudDialogDelete()"
			:atConfirm="deleteModels"
			:confirm="{label:'Procedi', color:'info'}"
		></confirm-dialog>		
	
		</div>
	</div>
	</v-card>
</template>

<script>
	import Vue from 'vue'
	import axios from 'axios'
	import Maps from '@/components/common/Maps'
	import DataTableMixin from '@/mixins/DataTableMixin'
    import ClisFooter from '@/components/modules/act/ClisFooter'
	import ColumnsSelector from '@/components/common/ColumnsSelector'
	import AdvancedFiltersDrawer from '@/components/common/AdvancedFiltersDrawer'
	import ViewsPanel from '@/components/common/ViewsPanel'
	import ButtonsGenerator from '@/components/common/ButtonsGenerator'
	import CrudExportDialog from '@/components/common/CrudExportDialog'
	import { loadListRows } from '@/services/bulkSelection'
	import { MAX_EXPLICIT_ITEMS } from '@/services/crudExport'
    import DeadlinesFooter from '@/components/modules/deadlines/DeadlinesFooter'
    import PaymentsFooter from '@/components/modules/deadlines/PaymentsFooter'
	import UploadFileButton from '@/components/common/UploadFileButton'
	import GenerateInterventionButton from '@/components/modules/tickets/GenerateInterventionButton'
	import SendMachineprocessButton from '@/components/modules/banci/SendMachineprocessButton'
	import PortalResetPassword from '@/components/modules/portal/PortalResetPassword'
	import PortalImpersonate from '@/components/modules/portal/PortalImpersonate'
	import PortalResetTwoFactor from '@/components/modules/portal/PortalResetTwoFactor'
	import { safeLocalStorageSet } from '@/services/local-storage-safe'
	import TotalsFooter from '@/components/common/TotalsFooter'
	import NumberingGapsAlert from '@/components/common/NumberingGapsAlert'
	import NumberingGapsContainer from '@/components/common/NumberingGapsContainer'
	import { filtersDrawerWidth } from '@/utils/filtersDrawer'

	export default {
		name: 'crud',
		mixins: [DataTableMixin],
		components: {
			Maps,
			ClisFooter,
			PaymentsFooter,
			DeadlinesFooter,
			ColumnsSelector,
			AdvancedFiltersDrawer,
			TotalsFooter,
			ViewsPanel,
			ButtonsGenerator,
			CrudExportDialog,
			UploadFileButton,
			SendMachineprocessButton,
			GenerateInterventionButton,
			PortalResetPassword,
			PortalImpersonate,
			PortalResetTwoFactor,
			NumberingGapsAlert,
			NumberingGapsContainer,
		},
		props: {
			title: String,
			entityTitle: String,
			actionIcon: String,
			modelDef: String,
			modelDefInfo: String,
			// Nome (senza suffisso) da usare per le rotte show/edit al posto di
			// modelDef: serve alle liste che condividono il modelDef con un'altra
			// entita' (es. le matricole, che sono Lotti filtrati ma hanno una
			// scheda/rotta dedicata) senza toccare l'endpoint API chiamato.
			routeModel: String,
			subFilters: Object,
			actionPosition: String,
			defaultInput: Object,
			redirect: Object,
			speedDialOptions: Object,
			positionRight: {
				type: Boolean,
				default: true
			},
			positionLeft: {
				type: Boolean,
				default: false
			},
			direction: {
				type: String,
				default: 'left'
			},
			crudDialog: {
				type: Boolean,
				default: false
			},
			saveAndNew: {
				type: Boolean,
				default: false
			},			
			urlAppend: {
				type: String,
				default: ''
			},
			actionsExpand: {
				type: Boolean,
				default: false
			},
			cardClasses: {
				type: [String, Array, Object],
				default: 'round-card background-2'
			},
			// Numbering alert props
			enableNumberingAlert: {
				type: Boolean,
				default: false
			},
			// Chiavi di buttonDefs da nascondere per questa istanza (es. 'add'
			// su una tab che mostra record collegati a un genitore, dove il
			// pulsante "Nuovo" creerebbe record scollegati). Filtro solo
			// client-side: non e' una barriera di sicurezza, l'endpoint resta
			// raggiungibile.
			excludedButtons: {
				type: Array,
				default: () => []
			}
		},

		data() {
			return {
				disabled: true,
				fab: false,
				infoData: {},
				selected: [],
				// selezione "tutti" stile Gmail: vale per l'intero set filtrato, anche le pagine non caricate
				allSelected: false,
				allSelectedSignature: null,
				// righe dell'intera lista caricate per un'azione multipla in modalità "tutti"
				allSelectedRows: null,
				selectionProgress: null,
				selectionCancel: null,
				exportDialog: false,
				exportButton: null,
				search: '',
				totalItems: 0,
				items: [],
				loading: true,
				initialLoading: true,
				pagination: {},
				filtered: false,
				debouncer: {},
				requestSeq: 0,
				// annullamento della richiesta index in volo (axios 0.21: CancelToken)
				cancelSource: null,
				advancedFilters: {},
				viewFilters: {},
				showFilters: false,
				showFiltersDrawer: false,
				showDial: true,
				tableDense: false,
				columnSelect: [],
				showColumnsSelector: false,
				filterSelected: {},
				support: {},
				//dialog datas
				showDialog: false,
				model: {},
				fieldsset: false,
				saved: false,
				// footer crud
				otherData: null,
				// totali sull'intero set filtrato (chiave totals della index)
				totals: null,
				// totali di colonna configurabili (chiave column_totals dentro
				// la paginazione), resi in fondo alla tabella
				columnTotals: null,
				totalsSignature: null,
				footerComponent: null,
				// multipleEdit
				multipleEdit: false,
				first: true,

				expanded: [],
				transitioned: [],
				closeTimeouts: {},
				singleExpand: false,
				reloadOffline: true,
				recoveringOnline: false,
				showMaps: false,
                confirmDelete: false,
				type: '',
				expand: false,

				contextMenu: {
					show: false,
					x: 0,
					y: 0,
					item: null,
				},

				// MeiliSearch
				useMeiliSearch: false,
				// fallback temporaneo alla ricerca standard dopo un errore della ricerca smart
				meiliFallback: false,

				// Auto-refresh
				autoRefreshInterval: null,
				autoRefreshTimer: null,
				refreshing: false,
				autoRefreshOptions: [
					{ text: 'Disattivato', value: null },
					{ text: 'Ogni 30 secondi', value: 30000 },
					{ text: 'Ogni minuto', value: 60000 },
					{ text: 'Ogni 5 minuti', value: 300000 },
				],
			}
		},

		watch: {

			singleExpand (v) {
				if (!v) return
				// Single expand enabled. Hide all but the first expanded item
				this.expanded.forEach((item, i) => {
					if (i > 0) this.closeExpand(item)
				})
			},

			pagination: {
				handler: function(newValue, oldValue) {
					// nuova paginazione: ritenta la ricerca smart se era in fallback
					this.meiliFallback = false
					if(! _.isEmpty(oldValue) ){
						if(_.isEmpty(this.subFilters))
							localStorage.setItem('crud_pagination_'+this.modelDef, JSON.stringify(newValue))
					}
					// Primo trigger con filtri avanzati salvati: il fetch parte
					// dall'evento filters_ del drawer (che li riapplica), qui si
					// salta per non fare la richiesta doppia senza filtri.
					// Chiavi attuali del drawer + quella legacy per retrocompatibilita'
					if(this.$store.getters.isOffline || !this.first || !this.hasSavedAdvancedFilters() || !_.isEmpty(this.subFilters)) {
						this.getDataFromApi()
					}
					this.first = false
				},
				deep: true,
			},

			search: {
				handler() {
					// nuovo termine: ritenta la ricerca smart se era in fallback
					this.meiliFallback = false
					if(_.isEmpty(this.subFilters)) {
						if(this.search == null) {
							localStorage.removeItem('crud_search_'+this.modelDef)
						} else {
							localStorage.setItem('crud_search_'+this.modelDef, this.search)
							this.pagination.page = 1
						}
					}
				}
			},

			items(items) {
				if(this.allSelected) {
					this.selected = items.slice()
				}
			},

			selected() {
				// deselezionare una riga esce dalla modalità "tutti" e tiene la selezione della pagina
				if(this.allSelected && !this.pageFullySelected) {
					this.allSelected = false
				}
			},

			allSelected(value) {
				if(!value) {
					this.allSelectedRows = null
				}
			},

			selectionSignature(signature) {
				if(this.allSelected && signature !== this.allSelectedSignature) {
					this.clearSelection()
				}
			},

			'infoData.fieldDefs': {
				handler() {
					this.stripHiddenSort()
				},
				deep: true,
			},

			// Se il componente e' nato mentre lo store era offline e la -info non
			// era in IndexedDB, la tabella resta vuota: al ritorno della rete va
			// recuperata dall'API, nessun altro la richiede
			'$store.getters.isOnline': function(online) {
				if(online && !this.infoData.modelDef) {
					this.recoverInfoDataOnline()
				}
			},

		},

		computed: {

			expandActionFieldKey() {
				let header = this.showHeaders.find((item) => {
					return item.actions !== undefined
				})
				if(header) {
					let action = header.actions.find(obj => {
						return obj.expand !== undefined
					})

					return action ? action.field_key : false
				} else {
					return false
				}
			},

			realSearch() {
				if(this.$store.getters.isOffline) {
					return this.search
				} else {
					return undefined
				}
			},

			countSelected() {
				return this.allSelected ? this.realTotalItems : this.selected.length
			},

			// id su cui gira un'azione multipla: in "tutti" quelli dell'intera lista
			actionSelectedIds() {
				return this.allSelected && this.allSelectedRows ? this.allSelectedRows.map(row => row.id) : this.selectedIds
			},

			// Filtri della tabella per i dialog che risolvono "tutti" sul backend (select_all):
			// Model::queryFilters li legge con questi nomi. Con la ricerca smart null: il backend
			// rifarebbe una ricerca SQL, non quella di Meilisearch, e quei dialog ricevono gli id
			listFilters() {
				if (this.usesMeiliSearch()) {
					return null
				}
				return {
					advancedFilters: this.advancedFilters,
					viewFilters: this.viewFilters,
					filter: this.search,
					subFilters: this.subFilters,
				}
			},

			// Il CSV segue l'ordine della tabella, non quello dei clic; le righe
			// selezionate su altre pagine restano in coda
			selectedInTableOrder() {
				const position = new Map(this.items.map((item, i) => [item.id, i]))
				return this.selected
					.map((item, i) => ({ item, key: position.has(item.id) ? position.get(item.id) : this.items.length + i }))
					.sort((a, b) => a.key - b.key)
					.map(ranked => ranked.item)
			},

			pageFullySelected() {
				if(!this.items.length) return false
				const ids = new Set(this.selected.map(item => item.id))
				return this.items.every(item => ids.has(item.id))
			},

			// Pagina che contiene l'intera lista (righe per pagina «Tutti») tutta spuntata: il banner
			// non compare; oltre il limite della selezione manuale l'export va in coda come "tutti"
			exportsWholeList() {
				return this.allSelected
					|| (this.pageFullySelected && typeof this.totalItems === 'number' && this.items.length >= this.totalItems
						&& this.items.length > MAX_EXPLICIT_ITEMS)
			},

			showSelectAllBanner() {
				return this.allSelected
					|| (this.pageFullySelected && typeof this.totalItems === 'number' && this.totalItems > this.items.length)
			},

			// Il set a cui si riferisce "tutti": se cambia, la selezione non vale piu'
			selectionSignature() {
				return JSON.stringify({
					advancedFilters: this.advancedFilters,
					viewFilters: this.viewFilters,
					filter: this.search,
					subFilters: this.subFilters,
					meili: this.useMeiliSearch,
				})
			},

			realTotalItems() {
				if(typeof this.totalItems === 'undefined') {
					return this.items.length
				} else {
					return this.totalItems
				}
			},

			calcHeight() {
				return (this.totalItems - (this.pagination.itemsPerPage * this.pagination.page)) >= 0 ? window.innerHeight - 350 + 'px' : 'auto'
			},

			showHeaders() {
				const visible = (this.fieldDefs || []).filter((item) => {
					return !!item.hide
				})
				// Difesa: stato incoerente (flag di visibilita' persi o cache
				// corrotta) → meglio mostrare tutte le colonne che nessuna
				return visible.length ? visible : (this.fieldDefs || [])
			},

			// La riga totali compare solo se il backend ha calcolato almeno un
			// totale per una colonna attualmente visibile
			hasColumnTotalsRow() {
				if (!this.columnTotals) {
					return false
				}
				return this.showHeaders.some((header) => this.columnTotalValue(header) !== undefined)
			},

			itemColumnName(value) {
				return (value) => {
					return 'item.' + value
				}
			},

			getCache() {
				return _.isEmpty(this.subFilters)
			},

			// Numbering alert computed properties
			showNumberingAlert() {
				if (!this.enableNumberingAlert) return false
				if (!this.numberingModelType) return false

				// Check if numbering check is enabled for this model type from settings
				const settingKey = `enable_numbering_check`
				const isEnabled = this.$store.getters.getSettingByModel(this.numberingModelType, settingKey)

				return isEnabled === true || isEnabled === 'true' || isEnabled === 1
			},

			numberingModelType() {
				if (!this.modelDef) return null

				// Handle documents-{type} pattern
				if (this.modelDef.startsWith('documents-')) {
					return this.modelDef.replace('documents-', '')
				}

				// Handle plural forms
				const mapping = {
					'quotations': 'quotation',
					'ddts': 'ddt',
					'saleorders': 'saleorder'
				}

				return mapping[this.modelDef] || this.modelDef
			},

			numberingCheckSectionals() {
				// Get the list of sectionals to check from settings
				const settingKey = 'numbering_check_sectionals'
				const sectionals = this.$store.getters.getSettingByModel(this.numberingModelType, settingKey)

				// If sectionals is an array, return it; otherwise return null (check all)
				if (Array.isArray(sectionals) && sectionals.length > 0) {
					return sectionals
				}

				return null // null means check all sectionals
			},


			filterSelectedName() {
				return this.filterSelected?.title ? `(${this.filterSelected.title})` : ''
			},

			viewFilterLabel() {
				const saved = localStorage.getItem('crud_viewFilter_' + this.modelDef)
				if (saved) {
					try {
						const data = JSON.parse(saved)
						return data.label || ''
					} catch(e) {
						return ''
					}
				}
				return ''
			},

			mapPermission() {
				return this.infoData && this.infoData.maps && this.$store.getters.checkSettings('map')
			},

			infoDataGeneralType(headerValue, item) {
				return (headerValue, item) => {
					if(this.infoData['general_types'] && this.infoData['general_types'][headerValue] && this.infoData['general_types'][headerValue][item[headerValue]] && this.infoData['general_types'][headerValue][item[headerValue]]['extra_fields']) {
						return this.infoData['general_types'][headerValue][item[headerValue]]['extra_fields']
					} else return null
				}
			},

			formatCustomClass() {
				return (value) => {
					return value ? value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') : '';
				}
			},

			// Empty state computed properties
			getEmptyStateIcon() {
				const modelDef = this.modelDef?.toLowerCase() || ''

				if (modelDef.includes('compan') || modelDef.includes('aziend')) return 'business'
				if (modelDef.includes('product') || modelDef.includes('prodott')) return 'inventory_2'
				if (modelDef.includes('order') || modelDef.includes('ordin')) return 'shopping_cart'
				if (modelDef.includes('invoice') || modelDef.includes('fattur')) return 'receipt'
				if (modelDef.includes('task') || modelDef.includes('attivit')) return 'task_alt'
				if (modelDef.includes('ticket')) return 'mdi-face-agent'
				if (modelDef.includes('quot') || modelDef.includes('prevent')) return 'description'
				if (modelDef.includes('ddt') || modelDef.includes('trasport')) return 'local_shipping'
				if (modelDef.includes('opportunit')) return 'trending_up'
				if (modelDef.includes('project') || modelDef.includes('progett')) return 'work'
				if (modelDef.includes('contact') || modelDef.includes('contatt')) return 'contacts'
				if (modelDef.includes('user') || modelDef.includes('utent')) return 'people'

				return 'folder_open'
			},

			getEmptyStateTitle() {
				// $trans dal backend; se modelTitle non è tradotto (ritorna la chiave grezza,
				// es. 'ddt_port'), ripiega sul title leggibile del crud.
				const translatedTitle = this.emptyStateLabel('Elementi')
				return `Nessun ${translatedTitle.toLowerCase()} trovato`
			},

			getEmptyStateSubtitle() {
				// $trans dal backend; fallback al title leggibile come sopra.
				const translatedTitle = this.emptyStateLabel('elemento')
				return `Non hai ancora creato nessun ${translatedTitle.toLowerCase()}. Inizia creando il primo per gestire i tuoi dati.`
			},

			getEmptyStateAction() {
				// Use $trans to get translation from backend
				const translatedTitle = this.infoData.modelTitle ? this.$trans(this.infoData.modelTitle) : (this.title || 'Elemento')
				return `Crea ${translatedTitle}`
			},

			autoRefreshLabel() {
				const option = this.autoRefreshOptions.find(o => o.value === this.autoRefreshInterval)
				return option ? option.text : ''
			},

			canCreate() {
				// Verifica se l'utente può creare nuovi elementi
				// Controlla se esiste un pulsante di creazione nelle azioni disponibili
				return this.infoData.modelDef && !this.crudDialog && this.$store.getters.isOnline
			}
		},

		methods: {

			// Etichetta per l'empty-state: usa la traduzione di modelTitle se esiste,
			// altrimenti (chiave non tradotta, es. 'ddt_port') ripiega sul title del crud.
			emptyStateLabel(fallback) {
				const t = this.infoData.modelTitle ? this.$trans(this.infoData.modelTitle) : null
				return (t && t !== this.infoData.modelTitle) ? t : (this.title || fallback)
			},

			getOutcomeColor(outcome) {
				return this.$eventBusUtility.callqueueOutcomeColor(outcome)
			},

			selectAll() {
				this.allSelected = true
				this.allSelectedSignature = this.selectionSignature
			},

			clearSelection() {
				this.allSelected = false
				this.selected = []
			},

			/**
			 * Fa:     carica tutte le righe della lista con la richiesta della tabella; l'avanzamento
			 *         annullabile compare nel banner solo se il caricamento dura (niente lampi su liste piccole)
			 * Output: Promise<righe>, null se annullato o in errore
			 */
			resolveAllSelected() {
				const source = axios.CancelToken.source()
				this.selectionCancel = source
				this.selectionProgress = { done: 0, total: this.realTotalItems, visible: false }
				const showTimer = setTimeout(() => {
					if(this.selectionProgress) {
						this.selectionProgress.visible = true
					}
				}, 500)
				return loadListRows(this.axios, this.exportListRequest(), {
					cancelToken: source.token,
					onProgress: (done, total) => {
						this.selectionProgress = { ...this.selectionProgress, done, total }
					},
				}).then(rows => {
					this.allSelectedRows = rows
					return rows
				}, () => null).finally(() => {
					clearTimeout(showTimer)
					this.selectionProgress = null
					this.selectionCancel = null
				})
			},

			cancelSelectionLoad() {
				if(this.selectionCancel) {
					this.selectionCancel.cancel()
				}
			},

			openExportDialog(button) {
				this.exportButton = button
				this.exportDialog = true
			},

			manualRefresh() {
				this.refreshing = true
				this.getDataFromApi()
				setTimeout(() => { this.refreshing = false }, 600)
			},

			hasSavedAdvancedFilters() {
				// Il drawer esiste solo se il modello ha availableFilters: senza
				// drawer nessuno riemetterebbe i filtri e il fetch non va saltato
				if(_.isEmpty(this.infoData.availableFilters)) {
					return false
				}
				for (const key of ['advanced_filter_', 'crud_advancedFilters_', 'availableFilterSelected_']) {
					try {
						if(!_.isEmpty(JSON.parse(localStorage.getItem(key + this.modelDef)))) {
							return true
						}
					} catch (e) {
						// valore corrotto in localStorage: come se non ci fosse
					}
				}
				return false
			},

			loadInfoData() {
				// Stale-while-revalidate: l'ultima -info vista e' buona per partire
				// subito (campi e colonne cambiano di rado), quella fresca arriva in
				// background e riapplica solo se diversa
				const cacheKey = 'crud_info_cache_' + (this.modelDefInfo ? this.modelDefInfo : this.modelDef)
				let cachedRaw = null
				try {
					cachedRaw = localStorage.getItem(cacheKey)
					if(cachedRaw) {
						this.applyInfoData(JSON.parse(cachedRaw))
					}
				} catch (e) {
					cachedRaw = null
				}
				this.axios.get((this.modelDefInfo ? this.modelDefInfo : this.modelDef) + '-info').then(response => {
					const fresh = JSON.stringify(response.data.info)
					this.writeInfoCache(cacheKey, fresh)
					if(fresh !== cachedRaw) {
						this.applyInfoData(response.data.info)
					}
				}, response => {
					// error callback
					this.loading = false
				})
			},

			writeInfoCache(cacheKey, fresh) {
				// La quota localStorage (~5MB, condivisa con tutte le chiavi crud_*) può
				// sforare con le -info più grosse (es. subscriptions): la cache è solo
				// un'ottimizzazione, il salvataggio non deve mai rompere il flusso.
				// Lo sfratto è condiviso con le altre cache CRUD rigenerabili, così lo
				// storage non resta incollato al tetto a spese delle scritture critiche.
				safeLocalStorageSet(cacheKey, fresh)
			},

			applyOfflineInfoData(info) {
				// Dexie .first() risolve a undefined quando il modello non e' mai
				// stato sincronizzato: info_data si popola solo in syncDB, che gira
				// solo per i profili col flag offline. Assegnare quel valore rende
				// infoData undefined e il template lo dereferenzia senza guardie,
				// quindi al primo ritorno online il render esplode. Meglio lasciare
				// infoData a {} e ripartire dall'API se la rete e' gia' tornata.
				if(!info || !info.fieldDefs) {
					if(this.$store.getters.isOnline) {
						// La rete e' tornata mentre leggevamo IndexedDB
						this.recoverInfoDataOnline()
						return
					}
					this.$store.commit('endProgress')
					this.$store.commit('setSnackbar', {
						timeout: 6000,
						text: 'Dati non disponibili offline per questa sezione',
						value: true,
						color: 'warning'
					})
					return
				}
				this.applyExcludedButtons(info)
				this.infoData = info
				this.setInfoData()
			},

			// Filtro client-side su buttonDefs in base alla prop excludedButtons:
			// stessa istanza di Crud usata su piu' rotte (es. la tab Pagamenti
			// dentro una scadenza) puo' voler nascondere un pulsante che altrove
			// resta visibile, senza toccare i buttonDefs lato server.
			applyExcludedButtons(info) {
				if (this.excludedButtons.length && info && Array.isArray(info.buttonDefs)) {
					info.buttonDefs = info.buttonDefs.filter((button) => !this.excludedButtons.includes(button.key))
				}
			},

			recoverInfoDataOnline() {
				// Il ramo online del created() non e' mai girato: va rifatto per
				// intero, watcher della ricerca compreso
				if(this.recoveringOnline) {
					return
				}
				this.recoveringOnline = true
				this.loadInfoData()
				this.$watch('search', () => this.getDataFromApi(500))
			},

			applyInfoData(info) {
				// Difesa: una -info vuota o una cache rigenerata male non deve
				// azzerare infoData, per lo stesso motivo di applyOfflineInfoData
				if(!info || typeof info !== 'object') {
					this.$store.commit('endProgress')
					return
				}
				// Ri-applicazione (refresh SWR): il selettore colonne ha gia'
				// impostato i flag di visibilita' (hide) sull'array corrente e il
				// suo created() non rigira. I flag vanno riportati sul nuovo array
				// PRIMA dell'assegnazione (cosi' Vue li osserva), altrimenti
				// showHeaders non trova colonne visibili e i click sul selettore
				// toccano proprieta' non reattive
				if (this.infoData.fieldDefs && info.fieldDefs) {
					// Dizionario senza prototipo: le chiavi arrivano dal server e
					// non devono poter collidere coi built-in (__proto__, constructor)
					const hideByValue = Object.create(null)
					this.infoData.fieldDefs.forEach((def) => {
						if (typeof def.hide !== 'undefined') {
							hideByValue[def.value] = def.hide
						}
					})
					info.fieldDefs.forEach((def) => {
						def.hide = typeof hideByValue[def.value] !== 'undefined' ? hideByValue[def.value] : true
					})
				}
				this.applyExcludedButtons(info)
				this.infoData = info
				this.columnSelect = this.infoData.fieldDefs

				if(this.infoData.footerComponent) {
					this.footerComponent = this.infoData.footerComponent
				}

				if(_.isEmpty(this.subFilters) && localStorage.getItem('crud_pagination_'+this.modelDef) !== null){
					let pag_temp = JSON.parse(localStorage.getItem('crud_pagination_'+this.modelDef))
					if(pag_temp.itemsPerPage == -1){
						delete pag_temp.itemsPerPage
					}
					Object.assign(this.pagination, this.cleanPagination(pag_temp))
				}
				else if(info.pagination) {
					Object.assign(this.pagination, info.pagination)
				}
				this.$store.commit('endProgress')
				setTimeout(() => { this.showDial = false }, this.$store.getters.dialTimeout)
			},

			setAutoRefresh(interval) {
				if (this.autoRefreshTimer) {
					clearInterval(this.autoRefreshTimer)
					this.autoRefreshTimer = null
				}

				this.autoRefreshInterval = interval

				if (interval) {
					this.autoRefreshTimer = setInterval(() => {
						// Tab in background: niente refresh, riprende alla prossima
						// scadenza con la tab visibile
						if(document.hidden) {
							return
						}
						this.refreshing = true
						this.getDataFromApi()
						setTimeout(() => { this.refreshing = false }, 600)
					}, interval)
				}
			},

			formatSlaMinutes(minutes) {
				if (minutes === null || minutes === undefined) return '—'
				const abs = Math.abs(minutes)
				const sign = minutes < 0 ? '-' : ''
				const h = Math.floor(abs / 60)
				const m = abs % 60
				if (h > 0) return `${sign}${h}h ${m}m`
				return `${sign}${m}m`
			},

			// Un link di cella può puntare a una scheda dell'applicazione
			// (percorso relativo calcolato dalla index, es. /troubles/123)
			// oppure a un indirizzo esterno
			// Firma del set filtrato: i totali si ricalcolano solo se cambia
			currentTotalsSignature() {
				return JSON.stringify({
					advancedFilters: this.advancedFilters,
					viewFilters: this.viewFilters,
					filter: this.search,
					subFilters: this.subFilters,
				})
			},

			// Dopo una modifica dei dati i totali vanno rifatti
			invalidateTotals() {
				this.totals = null
				this.columnTotals = null
				this.totalsSignature = null
			},

			// Valore della riga totali per una colonna: definito solo per le
			// colonne flaggate nella configurazione (fieldDef.total).
			// I null del backend restano celle vuote, non 0
			columnTotalValue(header) {
				if (!this.columnTotals || !header.total) {
					return undefined
				}
				const value = this.columnTotals[header.key || header.value]
				return value === null || value === '' ? undefined : value
			},

			// Un link di cella punta a un indirizzo esterno (link_key) oppure a
			// una scheda dell'applicazione: in quel caso la riga porta anche il
			// modelDef di destinazione (link_route_key), da cui si ricava il
			// nome di rotta <modelDef>-show. I percorsi non sono ricavabili dal
			// modelDef, quindi il link si risolve per nome
			goToLinkCell(header, item, event) {
				if (!event || !(event.button === 1 || event.button === 0 || event.ctrlKey || event.metaKey)) {
					return
				}

				if (!header.link_route_key) {
					// L'indirizzo arriva dai dati: la nuova scheda non deve poter
					// raggiungere window.opener
					window.open(item[header.link_key], '_blank', 'noopener,noreferrer')
					return
				}

				const route = {
					name: item[header.link_route_key] + '-show',
					params: { id: parseInt(item[header.link_key]) },
				}

				// Click centrale o con modificatore: nuova scheda, come sul resto della tabella
				if (event.button === 1 || event.ctrlKey || event.metaKey) {
					window.open(this.$router.resolve(route).href, '_blank', 'noopener,noreferrer')
				} else {
					this.$router.push(route).catch(() => {})
				}
			},

			openContextMenu(event, item) {
				event.preventDefault()
				this.contextMenu = {
					show: true,
					x: event.clientX,
					y: event.clientY,
					item: item,
				}
			},

			editInNewTab(id) {
				if(this.modelDef.startsWith('documents-')) {
					this.$eventBusUtility.goTo(this.$router, 'documents-edit', id, null, {doctype: this.modelDef.slice('documents-'.length)})
				} else {
					this.$eventBusUtility.goTo(this.$router, (this.routeModel || this.modelDef) + '-edit', id)
				}
			},

			clearSort() {
				this.pagination = { ...this.pagination, sortBy: [], sortDesc: [] }
			},

			// Filtra una coppia sortBy/sortDesc tenendo solo le colonne il cui value e'
			// in validValues. Ricostruisce i due array in parallelo (no splice, no disallineo).
			pruneSort(sortBy, sortDesc, validValues) {
				const outBy = []
				const outDesc = []
				;(sortBy || []).forEach((field, i) => {
					if(validValues.includes(field)) {
						outBy.push(field)
						outDesc.push(sortDesc && sortDesc[i] != null ? sortDesc[i] : false)
					}
				})
				return { sortBy: outBy, sortDesc: outDesc }
			},

			// Ritorna sortBy/sortDesc filtrati sulle sole colonne visibili.
			// Se le colonne non sono ancora caricate ritorna il sort grezzo (no-op).
			visibleSort() {
				if(!this.showHeaders || !this.showHeaders.length)
					return { sortBy: this.pagination.sortBy || [], sortDesc: this.pagination.sortDesc || [] }
				return this.pruneSort(this.pagination.sortBy, this.pagination.sortDesc, this.showHeaders.map(h => h.value))
			},

			// Ripulisce pagination dal sort delle colonne nascoste.
			// Riassegna l'intero oggetto pagination cosi' Vuetify ricalcola il badge
			// multi-sort e il watcher pagination scatta (refresh).
			stripHiddenSort() {
				if(!this.pagination.sortBy || !this.pagination.sortBy.length) return
				if(!this.showHeaders || !this.showHeaders.length) return
				const { sortBy, sortDesc } = this.visibleSort()
				if(sortBy.length !== this.pagination.sortBy.length) {
					this.pagination = { ...this.pagination, sortBy, sortDesc }
				}
			},

			cleanPagination(pagination) {
				if(pagination.sortBy) {
					const valid = (this.infoData.fieldDefs || []).map(h => h.value)
					const { sortBy, sortDesc } = this.pruneSort(pagination.sortBy, pagination.sortDesc, valid)
					pagination.sortBy = sortBy
					pagination.sortDesc = sortDesc
				}

				return pagination
			},
			isBarred(item) {
				if(typeof this.infoData.barred !== 'undefined') {
					return item[this.infoData.barred.key]
				} else {
					return false
				}
			},

			toggleActionsExpand() {
				this.$emit('update:actionsExpand', !this.expand)
				this.expand = !this.expand
			},

            cloneItem(item) {
				// open show clone in dialog (edit)

				let urlWithAppend = this.urlAppend != '' ? '/' + this.urlAppend : ''
				this.axios.get(this.modelDef + urlWithAppend + '/' + item.id + '/edit').then(response => {
					this.fieldsset = response.data.fields
					this.model = response.data.model
					this.showDialog = true
					this.type = 'clone'
					delete this.model.id
				}, response => {
					// error callback
				})
            },

			crudDialogDelete(item) {
				this.selected = [item]
				this.confirmDelete = true
			},

			cancelCrudDialogDelete() {
				this.selected = []
				this.confirmDelete = false
			},

            // Call at change select option
            onChange(field, event) {
                Promise.all(this.$eventBusUtility.fieldsGeneratorConditions(field, event, this.fieldsset, this.model, this.support, this.defaultInput)).then((responses) => {
                    responses.forEach(response => {
                        if(this.model[response.key]) {
                            this.$refs.fieldsgenerator.$refs[response.key][0].$emit('change', this.model[response.key])
                        }
                    })
                })
            },

			toggleExpand (item, isExpanded, expand) {
				const id = item.id
				if (isExpanded && this.transitioned[id]) {
					// If we're expanded and not in the process of closing, close
					this.closeExpand(item)
				} else {
					// If we're closed or in the process of closing, expand
					// Stop us from closing if a close transition was started
					clearTimeout(this.closeTimeouts[id])
					// Tell v-data-table to add the expansion content for the item
					expand(true)
					// Show expansion content with transition animation after it's had time to get added to the DOM
					this.$nextTick(() => this.$set(this.transitioned, id, true))
					// Hide all other expanded items if single-expand
					if (this.singleExpand) this.$nextTick(() => this.expanded.forEach(i => i !== item && this.closeExpand(i)))
				}
			},

			closeExpand (item) {
				const id = item.id
				// Mark that this item is in the process of closing
				this.$set(this.transitioned, id, false)
				// Remove expansion content from DOM after transition animation has had enough time to finish
				this.closeTimeouts[id] = setTimeout(() => this.$refs.vDataTable.expand(item, false), 200)
			},

			// Row action filtrate per permessi di modulo e setting, come i bottoni
			visibleRowActions(actions) {
				return (actions || []).filter(action => this.$eventBusUtility.showButton(action))
			},

			generateDefaultInput(item, defaultInput) {
				let params = {}
				if(defaultInput) {
					_.forEach(defaultInput, (value, key) =>{
						params[key] = item[value]
					})
				}
				return params
			},

			getDataFromApi(delay = 150) {
				// Ogni invocazione invalida le risposte in volo delle precedenti (race su risposte fuori ordine)
				const requestId = ++this.requestSeq

				if(this.debouncer)
					clearTimeout(this.debouncer)

				// Il debounce lungo serve solo alla digitazione nella ricerca (500ms,
				// passato dal watcher di search); per pagina/sort/viste/refresh basta
				// una finestra minima che collassi i trigger multipli dello stesso burst
				this.debouncer = setTimeout(() => {
					this.loading = true
					// Le richieste superate vengono annullate davvero, non solo scartate
					// alla risposta: liberano subito connessione browser e worker PHP
					if(this.cancelSource) {
						this.cancelSource.cancel()
					}
					this.cancelSource = axios.CancelToken.source()
					if(this.$store.getters.isOffline) {
						this.$store.getters.getData(this.infoData.modelDef).then((a) => {
							if(requestId !== this.requestSeq) return
							if(typeof a !== 'undefined') {
								this.items = a
							} else {
								this.items = []
							}
							this.totalItems = undefined
							this.loading = false
							this.initialLoading = false
						})
					} else {
						// Use MeiliSearch if enabled and search has text
						if (this.usesMeiliSearch()) {
							this.searchWithMeiliSearch(requestId)
						} else {
							// Standard search
							// I totali costano una query aggregata sull'intero set:
							// si richiedono solo quando il set filtrato cambia,
							// non a ogni cambio di pagina o ordinamento
							// Il confronto non guarda infoData.totalsDefs: i metadati
							// arrivano da una richiesta separata e possono non essere
							// ancora pronti al primo caricamento della lista
							const totalsSignature = this.currentTotalsSignature()
							const withTotals = totalsSignature !== this.totalsSignature
							let dataObject = {
								...this.listPayload(this.pagination.page, this.pagination.itemsPerPage),
								with_totals: withTotals,
							}
							let url = this.infoData.modelDef + '-filters'
							this.axios.post(url, dataObject, { cancelToken: this.cancelSource.token }).then(response => {
								if(requestId !== this.requestSeq) return
								this.loading = false
								this.initialLoading = false
								this.items = response.data.data.data
								this.totalItems = response.data.data.total
								this.otherData = response.data.data.otherdata
								if(withTotals) {
									this.totals = response.data.totals || null
									this.columnTotals = response.data.data.column_totals || null
									this.totalsSignature = totalsSignature
								}
							}, response => {
								// error callback
								if(requestId !== this.requestSeq) return
								this.loading = false
								this.initialLoading = false
							})
						}
					}
				}, delay)
			},

			// Richiesta della lista: la stessa per la tabella e per l'export (stessi filtri,
			// ricerca, vista e ordinamento), cambia solo la pagina
			listPayload(page, perPage) {
				const { sortBy, sortDesc } = this.visibleSort()
				return {
					page,
					per_page: perPage,
					sortBy,
					sortDesc,
					advancedFilters: this.advancedFilters,
					viewFilters: this.viewFilters,
					filter: this.search,
					subFilters: this.subFilters,
				}
			},

			meiliPayload(page, perPage) {
				const { sortBy, sortDesc } = this.visibleSort()
				return {
					model_class: this.modelDef,
					query: this.search,
					action: 'index',
					per_page: perPage,
					page,
					sortBy,
					sortDesc,
					advancedFilters: this.advancedFilters,
					viewFilters: this.viewFilters,
					subFilters: this.subFilters,
				}
			},

			usesMeiliSearch() {
				return this.useMeiliSearch && !this.meiliFallback && !!this.search && this.search.length > 0
			},

			// Richiesta lista della tabella, ripetuta a pagine in modalità "tutti" (export CSV sul backend, azioni multiple qui)
			exportListRequest() {
				if (this.usesMeiliSearch()) {
					return { uri: 'meilisearch/search', payload: this.meiliPayload(1, 1) }
				}
				return { uri: this.infoData.modelDef + '-filters', payload: this.listPayload(1, 1) }
			},

			searchWithMeiliSearch(requestId) {
				// Minimo 2 caratteri per ricerca MeiliSearch
				//if (!this.search || this.search.length < 2) {
				//	return
				//}

				const searchData = this.meiliPayload(this.pagination.page || 1, this.pagination.itemsPerPage || 15)

				this.axios.post('meilisearch/search', searchData, { cancelToken: this.cancelSource.token }).then(response => {
					if(requestId !== this.requestSeq) return
					this.loading = false
					this.initialLoading = false
					this.items = response.data.data
					this.totalItems = response.data.pagination.total
					// la ricerca smart non calcola i totali
					this.invalidateTotals()
				}).catch(error => {
					if(requestId !== this.requestSeq) return
					this.loading = false
					this.initialLoading = false

					// Fallback to standard search on error
					this.$store.commit('setSnackbar', {
						timeout: 6000,
						text: 'Errore ricerca smart, utilizzo ricerca standard',
						value: true,
						color: 'warning'
					})

					// Fallback alla ricerca standard solo per questa richiesta: la preferenza
					// (e l'icona del toggle) resta invariata, il flag viene resettato al
					// prossimo cambio di termine o di paginazione
					this.meiliFallback = true
					this.getDataFromApi()
				})
			},

			toggleMeiliSearch() {
				this.useMeiliSearch = !this.useMeiliSearch
				this.meiliFallback = false

				// Save preference in localStorage
				if (this.modelDef) {
					localStorage.setItem('useMeiliSearch_' + this.modelDef, this.useMeiliSearch)
				}

				// Refresh data if there's a search query
				if (this.search) {
					this.getDataFromApi()
				}

				// Show notification
				const message = this.useMeiliSearch
					? 'Ricerca Smart attivata'
					: 'Ricerca Standard attivata'

				this.$store.commit('setSnackbar', {
					timeout: 3000,
					text: message,
					value: true,
					color: 'info'
				})
			},

			openShow(item, blank = false) {
				if(!this.infoData.notOpenShow) {
					// Una riga può dichiarare la propria destinazione (router_route
					// + router_id, oppure router_url): nelle liste polimorfe è
					// l'unico modo di raggiungere la scheda giusta, e ha la
					// precedenza sul dialog di modifica
					if(this.crudDialog && !item.router_route && !item.router_url) {
						// open show in dialog (edit)

						let urlWithAppend = this.urlAppend != '' ? '/' + this.urlAppend : ''
						this.axios.get(this.modelDef + urlWithAppend + '/' + item.id + '/edit').then(response => {

						this.fieldsset = response.data.fields
						this.model = response.data.model
						this.showDialog = true
						this.type = 'create'
						//this.$refs.customfielddialog.show = true

						}, response => {
							// error callback
						})
					} else if(item.router_route || item.router_url) {
					// Salva contesto navigazione prima di navigare
					this.saveNavigationContext(item)
						const destination = item.router_route
							? { name: item.router_route + '-show', params: { id: parseInt(item.router_id) } }
							: { path: item.router_url }
						if(blank) {
							window.open(this.$router.resolve(destination).href, '_blank', 'noopener,noreferrer')
						} else {
							this.$router.push(destination).catch(() => {})
						}
					} else {
						// Salva contesto navigazione prima di navigare
						this.saveNavigationContext(item)
						// open in other view
						let routeParams = this.infoData.routeParams
						let showRoute = (this.routeModel || this.modelDef) + '-show'
						if(this.infoData.showRoute) {
							showRoute = this.infoData.showRoute
						}
						if(blank) {
							const url = this.$router.resolve({ name: showRoute, params: { id: parseInt(item.id), redirect: this.redirect, ...routeParams }}).href
							window.open(url, '_blank')
						} else {
							this.$router.push({ name: showRoute, params: { id: parseInt(item.id), redirect: this.redirect, ...routeParams }})
						}
					}
				} 
			},

			openCreate(params = {}) {
				if(this.crudDialog) {
					// open create in dialog
					this.create({...params, ...this.defaultInput})
				} else {
					let buttonParams = this.infoData.routeParams
					// stessa convenzione di showRoute/goTo edit: routeModel vince su modelDef
					// (liste come le matricole condividono modelDef 'lots' con i lotti ma
					// hanno rotte create/show/edit dedicate)
					let createRoute = (this.routeModel || this.modelDef) + '-create'
					if(this.infoData.createRoute) {
						createRoute = this.infoData.createRoute
					}
					// open in other view
					this.$router.push({ name: createRoute, params: {defaultInput: this.defaultInput, redirect: this.redirect, ...buttonParams}})
				}
			},

			create(params) {
				this.axios.get(this.modelDef + '/create', {params: params}).then(response => {

					this.fieldsset = response.data.fields
					this.showDialog = true
					this.type = 'create'
					// remove validations rule
					if(params && params.field_filters && params.field_filters.multiple_edit) {
						this.fieldsset.fields.map((field) => {
							delete field.required
							delete field.validations
							return field
						})
					} else {
						_.forEach(this.fieldsset.fields, (value, key) => {
							if(value.type === 'checkbox' || value.type === 'file') {
								Vue.set(this.model, value.key, '')
							}
							if(value.default) {
								Vue.set(this.model, value.key, value.default)
							}
						})

						// Imposta i valori di defaultInput sul model e precarica le option
						// dei campi async precompilati (es. azienda) così da mostrarne subito
						// l'etichetta nel dialog. checkDefaultInput fa già il Vue.set dei valori.
						this.$eventBusUtility.checkDefaultInput(this, 'model')
					}

				}, response => {
					// error callback
				})
			},

			closeDialog(saveAndCreate = false) {
				if(!saveAndCreate) {
					this.showDialog = false
				}
				this.model = {}
				_.forEach(this.defaultInput, (value, key) => {
					this.$set(this.model, key, value)
				})				
				this.saved = false
			},

			saveModel(saveAndCreate = false) {
				// only for dialog
				this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
					if (!result) {
						return false
					}

					this.saved = true
					let urlWithAppend = this.urlAppend != '' ? '/' + this.urlAppend : ''
					
					if(_.has(this.model, 'id')) { // edit
						this.axios.put(this.modelDef + urlWithAppend + '/' + this.model.id, this.model).then(response => {
							// get body data
							let data = response.data
							this.invalidateTotals()
							this.getDataFromApi()
							let snackmessage = ''
							let snackcolor = ''
							if(data.status == 'message'){
								snackmessage = data.message
								snackcolor = 'warning'
							} else{
								snackmessage = 'Elemento aggiornato con successo.'
								snackcolor = 'success'
							}

							this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})

							this.closeDialog(saveAndCreate)
						}, response => {
							// error callback
							this.saved = false
						})
					} else if(this.multipleEdit) {
						this.axios.post('multiple/' + this.modelDef + urlWithAppend, {'model': this.model, 'ids': this.actionSelectedIds}).then(response => {
							// get body data
							let data = response.data
							this.invalidateTotals()
							this.getDataFromApi()
							this.closeDialog()
							let snackmessage = ''
							let snackcolor = ''
							if(data.status == 'message'){
								snackmessage = data.message
								snackcolor = 'warning'
							} else{
								snackmessage = 'Elementi aggiornati con successo.'
								snackcolor = 'success'
							}
							this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})
							this.multipleEdit = false

							this.$eventBusUtility.$emit('refreshTable_'+ this.modelDef)

						}, response => {
							// error callback
							this.saved = false
						})
					} else { // create

						this.axios.post(this.modelDef + urlWithAppend, this.model).then(response => {
								// get body data
							let data = response.data
							this.invalidateTotals()
							this.getDataFromApi()
							let snackmessage = ''
							let snackcolor = ''
							if(data.status == 'message'){
								snackmessage = data.message
								snackcolor = 'warning'
							} else{
								snackmessage = 'Elemento creto con successo.'
								snackcolor = 'success'
							}

							this.$eventBusUtility.$emit('modelCreated', data.id)

							this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})							
							
							this.closeDialog(saveAndCreate)

						}, response => {
							// error callback
							this.saved = false
						})
					}
				}).catch(() => {

				})
			},
		
			setInfoData() {
				// Invocata anche dall'event bus 'offline', quando la -info puo'
				// non essere ancora arrivata: senza guardia si perde endProgress
				// e la tab resta in caricamento per sempre
				if(!this.infoData || !this.infoData.fieldDefs) {
					this.$store.commit('endProgress')
					return
				}
				this.reloadOffline = false

				// Sezione senza filtri (o offline): il drawer non comparira' mai e
				// nessuno rilascerebbe lo spazio prenotato in created()
				if(_.isEmpty(this.infoData.availableFilters) || !this.$store.getters.isOnline) {
					this.$store.commit('setFilterDrawerReservedWidth', 0)
				}

				let position = this.infoData.fieldDefs.map(f => f.value).indexOf('actions')
				// Non tutti i modelli espongono la colonna azioni
				if(position !== -1 && this.infoData.fieldDefs[position].actions) {
					this.$set(this.infoData.fieldDefs[position], 'actions', this.infoData.fieldDefs[position].actions.filter(a => a.offline))
				}
				this.columnSelect = this.infoData.fieldDefs
				this.maxUsers = this.infoData.max_users
				this.usersNumber = this.infoData.users_number
				if(_.isEmpty(this.subFilters) && localStorage.getItem('crud_pagination_'+this.modelDef) !== null){
					let pag_temp = JSON.parse(localStorage.getItem('crud_pagination_'+this.modelDef))
					if(pag_temp.rowsPerPage == -1){
						delete pag_temp.rowsPerPage
					}
					Object.assign(this.pagination, pag_temp)
				}
				else if(this.infoData.pagination) {
					Object.assign(this.pagination, this.infoData.pagination)
				}
				this.$store.commit('endProgress')
				setTimeout(() => { 
					this.showDial = false
					this.reloadOffline = true
					}, this.$store.getters.dialTimeout);
				
			},

			toggleMaps() {
				this.showMaps = !this.showMaps
			},

			clearFilters() {
				// Reset search
				this.search = ''

				// Reset advanced filters
				this.advancedFilters = {}
				this.filtered = false
				this.filterSelected = {}

				// Clear localStorage filters
				if (this.modelDef) {
					localStorage.removeItem('crud_search_' + this.modelDef)
					localStorage.removeItem('crud_advancedFilters_' + this.modelDef)
					localStorage.removeItem('availableFilterSelected_' + this.modelDef)
				}

				// Refresh data
				this.getDataFromApi()
			},

			saveNavigationContext(item) {
				// Salva il contesto di navigazione per permettere prev/next nella Show
				// Per i documenti, usa la chiave che la Show riceverà (con routeParams.doctype)
				let contextKey = this.modelDef
				if (this.infoData.showRoute === 'documents-show' && this.infoData.routeParams && this.infoData.routeParams.doctype) {
					contextKey = 'documents-' + this.infoData.routeParams.doctype
				}

				// Determina il route name da usare per la navigazione
				let showRoute = this.modelDef + '-show'
				if (this.infoData.showRoute) {
					showRoute = this.infoData.showRoute
				}

				const context = {
					ids: this.items.map(i => i.id),
					currentId: item.id,
					totalItems: this.totalItems,
					startPage: this.pagination.page,
					currentMaxPage: this.pagination.page,
					queryParams: {
						page: this.pagination.page,
						per_page: this.pagination.itemsPerPage,
						sortBy: this.pagination.sortBy,
						sortDesc: this.pagination.sortDesc,
						advancedFilters: this.advancedFilters,
						viewFilters: this.viewFilters,
						filter: this.search,
						subFilters: this.subFilters
					},
					timestamp: Date.now(),
					listRoute: this.$route.fullPath,
					showRoute: showRoute,
					routeParams: this.infoData.routeParams || {},
					filterEndpoint: this.modelDef
				}
				sessionStorage.setItem(`navigation_context_${contextKey}`, JSON.stringify(context))
			}

		},

		created() {

			// Il drawer dei filtri compare solo dopo la info API: se per questa
			// sezione risulta fissato prenotiamo subito il suo spazio, cosi' la
			// pagina non nasce a tutta larghezza per poi restringersi.
			if (localStorage.getItem('filter_drawer_pinned_' + this.modelDef) === 'true' && this.$vuetify.breakpoint.mdAndUp) {
				this.$store.commit('setFilterDrawerReservedWidth', filtersDrawerWidth(this.$vuetify))
			}

			if(_.isEmpty(this.subFilters) && localStorage.getItem('crud_search_'+this.modelDef) !== null){
				this.search = localStorage.getItem('crud_search_'+this.modelDef)
			}

			// Restore view filter from localStorage
			if(_.isEmpty(this.subFilters) && localStorage.getItem('crud_viewFilter_'+this.modelDef) !== null){
				try {
					const saved = JSON.parse(localStorage.getItem('crud_viewFilter_'+this.modelDef))
					this.viewFilters = (saved && saved.filter) ? saved.filter : {}
				} catch(e) {
					this.viewFilters = {}
				}
			}

			// Load MeiliSearch preference from localStorage only if feature is enabled
			if (this.$store.getters.checkSettings('global_search') && this.modelDef) {
				const stored = localStorage.getItem('useMeiliSearch_' + this.modelDef)
				if (stored !== null) {
					this.useMeiliSearch = stored === 'true'
				}
			} else {
				// Feature disabled: force standard search
				this.useMeiliSearch = false
			}

			if(this.$store.getters.isOffline) {
				this.$store.getters.getInfoData(this.modelDef).then((a) => {
					this.applyOfflineInfoData(a)
				}, () => {
					// IndexedDB non apribile (versione/quota): stesso fallback
					this.applyOfflineInfoData(null)
				})
			} else {
				// Get info data for model (cache stale-while-revalidate)
				this.loadInfoData()

				// Solo la digitazione merita il debounce lungo
				this.$watch('search', () => this.getDataFromApi(500))
			}
		},

		mounted() {

			this.$eventBusUtility.$on('refreshTable_'+this.modelDef, () => {
				this.getDataFromApi()
				this.disabled = true
				this.allSelected = false
				this.selected = []
			})
			
			this.$eventBusUtility.$on('offline', this.setInfoData)

			this.$eventBusUtility.$on('openCreate_'+this.modelDef,() => {
				this.openCreate()
			})

			this.$eventBusUtility.$on('multipleEdit_'+this.modelDef, (params) => {
				this.multipleEdit = true
				this.create(params)
			})

			this.$eventBusUtility.$on('filters_'+this.modelDef, (advancedFilters) => {
				this.advancedFilters = advancedFilters
				localStorage.setItem('crud_advancedFilters_'+this.modelDef, JSON.stringify(this.advancedFilters))
				this.getDataFromApi()
			})

			this.$eventBusUtility.$on('viewFilters_'+this.modelDef, (viewFilter) => {
				this.viewFilters = viewFilter || {}
				// Cambiare vista cambia l'insieme dei risultati: ripartire da pagina 1
				// evita la richiesta a vuoto su una pagina che non esiste piu'
				if(this.pagination.page !== 1) {
					this.pagination.page = 1
				}
				this.getDataFromApi()
			})
		},

		beforeDestroy() {
			// Clear auto-refresh timer
			if (this.autoRefreshTimer) {
				clearInterval(this.autoRefreshTimer)
			}
			// Removal of the listener of the event in order not to refresh the crud n times
			//eventBusUtility.$off('refreshTable')
			this.$eventBusUtility.$off('refreshTable_'+this.modelDef)
			this.$eventBusUtility.$off('openCreate_'+this.modelDef)
			this.$eventBusUtility.$off('multipleEdit_'+this.modelDef)
			this.$eventBusUtility.$off('filters_'+this.modelDef)
			this.$eventBusUtility.$off('viewFilters_'+this.modelDef)
			this.$eventBusUtility.$off('offline')
		},
	}

</script>
<style>
	.select-all-banner {
		position: relative;
		/* stessa altezza con la checkbox e con l'avanzamento: la tabella non salta */
		min-height: 36px;
		background-color: rgba(25, 118, 210, 0.08);
	}
	.barred-row {
		text-decoration: line-through;
		opacity: 0.6;
	}
	.priority {
		border-radius: 4px;
		padding: 4px;
		font-weight: 500 !important;
		color: white;
		max-width: 95px;
		text-align: center;
		font-size: 11px;
	}

	.squared-chip {
		border-radius: 4px;
		padding: 4px;
		font-weight: 500 !important;
		border: 1px solid;
		max-width: 200px;
		text-align: center;
	}
	.squared-chip-filled {
		border-radius: 4px;
		padding: 4px;
		font-weight: 500 !important;
		color: white;
		max-width: 95px;
		text-align: center;
		font-size: 11px;
		white-space: normal;
	}

	th.sortable {
		white-space: nowrap;
	}

	.v-data-table__wrapper {
		overflow-x: auto;
		overflow-y: auto;
		max-height: 66vh;
	}

	@media screen and (max-width: 600px) {
		.v-data-table__wrapper {
			max-height: 54vh;
		}
	}

	.theme--dark.v-data-table.v-data-table--fixed-header thead th, .theme--dark.v-data-table {
		background-color: #424242!important;
	}

	.v-data-table--fixed-header > .v-data-table__wrapper > table > thead > tr > th {
		top: -1px!important;
	}

	.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
		padding: 0 10px;
	}
	
	.v-data-table__progress > .column {
		height: 0px !important; padding: 0px !important; margin: 0px !important;
	}

	.auto-refresh-toggle {
		margin-left: -6px;
	}

	/* Riga dei totali di colonna: sticky in fondo all'area di scroll della
	tabella (il wrapper scrolla gia' al proprio interno con le max-height
	66vh/54vh qui sopra), cosi' resta visibile anche prima di arrivare a fine
	scroll. Stessi colori del fixed-header (il tema non genera le custom
	properties) */
	.v-data-table > .v-data-table__wrapper > table > tbody > tr.column-totals-row > td {
		position: sticky;
		bottom: 0;
		z-index: 2;
		background-color: #FFFFFF;
		border-top: thin solid rgba(0, 0, 0, 0.12);
	}

	.theme--dark.v-data-table > .v-data-table__wrapper > table > tbody > tr.column-totals-row > td {
		background-color: #424242;
		border-top-color: rgba(255, 255, 255, 0.12);
	}

	.spin-animation {
		animation: spin 0.6s linear;
	}
	@keyframes spin {
		from { transform: rotate(0deg); }
		to { transform: rotate(360deg); }
	}
</style>